/**
 * SourceGenerator Filters Component
 * Inline filter bar: filters stay visible and apply live (no popover).
 */
import React from 'react';
import { InlineFilterBar, InlineSelect, InlineToggles } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';
import {
  SourceGeneratorRiskType,
  SourceGeneratorStatus,
  RISK_TYPE_LABELS,
  STATUS_LABELS,
} from '../../../types/sourceGenerator';

export interface SourceFiltersData {
  searchTerm: string;
  riskType: string;
  status: string;
  maintenanceOverdue: boolean;
}

interface Props {
  onFilter: (filters: SourceFiltersData) => void;
  loading?: boolean;
  total?: number;
}

const RISK_TYPE_OPTIONS = Object.values(SourceGeneratorRiskType).map((t) => ({
  value: t,
  label: RISK_TYPE_LABELS[t],
}));
const STATUS_OPTIONS = Object.values(SourceGeneratorStatus).map((s) => ({
  value: s,
  label: STATUS_LABELS[s],
}));

const defaultValues: SourceFiltersData = {
  searchTerm: '',
  riskType: '',
  status: '',
  maintenanceOverdue: false,
};

export const SourceGeneratorFiltersComponent: React.FC<Props> = ({
  onFilter,
  loading = false,
  total,
}) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(defaultValues, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: {
      riskType: 'Risco',
      status: 'Status',
    },
    formatValue: {
      riskType: (v: string) => RISK_TYPE_LABELS[v as SourceGeneratorRiskType] ?? v,
      status: (v: string) => STATUS_LABELS[v as SourceGeneratorStatus] ?? v,
    },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Buscar por nome, código, localização..."
      searchValue={filters.searchTerm}
      onSearchChange={(v) => setFilter('searchTerm', v)}
      resultCount={total}
      resultNoun="fontes geradoras"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <InlineSelect
        label="Tipo de Risco"
        value={filters.riskType}
        options={RISK_TYPE_OPTIONS}
        onChange={(v) => setFilter('riskType', v)}
        emptyLabel="Todos"
        minWidth={160}
      />
      <InlineSelect
        label="Status"
        value={filters.status}
        options={STATUS_OPTIONS}
        onChange={(v) => setFilter('status', v)}
        emptyLabel="Todos"
        minWidth={160}
      />
      <InlineToggles
        disabled={loading}
        items={[
          {
            label: 'Manutenção atrasada',
            checked: filters.maintenanceOverdue,
            onChange: (v) => setFilter('maintenanceOverdue', v),
          },
        ]}
      />
    </InlineFilterBar>
  );
};

export default SourceGeneratorFiltersComponent;
